import BaseMiniPrinterDriver from './base-miniprinter-driver'
import miniprinterL from '../../assets/models/miniprinter-l.stl'
import { MiniPrinterIcon, AddMiniPrinterIcon } from '../../components/icons'

class MiniPrinterLDriver extends BaseMiniPrinterDriver {
  static readonly name = 'MiniPrinter L'
  static readonly model = 'miniprinter-l'
  static readonly icon = MiniPrinterIcon
  static readonly addIcon = AddMiniPrinterIcon
  protected static readonly stlModel = miniprinterL
  protected static readonly stlModelXOffset: number = -0.57
  protected static readonly stlModelYOffset: number = -0.23
  protected static readonly stlModelZOffset: number = -0.175

  protected static readonly HEIGHT_MM: number = 1200
  protected static readonly WIDTH_MM: number = 1200
  protected static readonly DEPTH_MM: number = 1200
}

export default MiniPrinterLDriver
